import { render } from "./policythirdshare.vue?vue&type=template&id=1a44bda0&scoped=true"
import script from "./policythirdshare.vue?vue&type=script&lang=js"
export * from "./policythirdshare.vue?vue&type=script&lang=js"

import "./policythirdshare.vue?vue&type=style&index=0&id=1a44bda0&scoped=true&lang=css"

import exportComponent from "/apps/srv/jenkins/workspace/feihua_fe_mqimengweb_online/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a44bda0"]])

export default __exports__